export default function PHP_is_null() {
  return (
    <div>
      <h1>PHP_is_null</h1>
    </div>
  );
}
